import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import AuthGate from '@/components/layout/AuthGate';
import AppShell from '@/components/layout/AppShell';
import { ToastContainer } from '@/components/ui/Toast';

const Login = lazy(() => import('@/pages/Login'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const CustomerRegister = lazy(() => import('@/pages/CustomerRegister'));
const CustomerSearch = lazy(() => import('@/pages/CustomerSearch'));
const CustomerEdit = lazy(() => import('@/pages/CustomerEdit'));
const SalesCounter = lazy(() => import('@/pages/SalesCounter'));
const CashierQueue = lazy(() => import('@/pages/CashierQueue'));
const Inventory = lazy(() => import('@/pages/Inventory'));
const Inbound = lazy(() => import('@/pages/Inbound'));
const Settings = lazy(() => import('@/pages/Settings'));
const Reports = lazy(() => import('@/pages/Reports'));
const PermissionGrid = lazy(() => import('@/pages/SettingsPermissionGrid'));
const SettingsUsers = lazy(() => import('@/pages/SettingsUsers'));
const CatalogImport = lazy(() => import('@/pages/CatalogImport'));
const CustomersBulk = lazy(() => import('@/pages/CustomersBulk'));
const DSRInbox = lazy(() => import('@/pages/DSRInbox'));
const ApprovalQueue = lazy(() => import('@/pages/ApprovalQueue'));
const Invoices = lazy(() => import('@/pages/Invoices'));
const CashierEod = lazy(() => import('@/pages/CashierEod'));

function Loading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-slate-500">Loading…</div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <AuthGate>
              <AppShell />
            </AuthGate>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/customers/new" element={<CustomerRegister />} />
          <Route path="/customers/:id/edit" element={<CustomerEdit />} />
          <Route path="/customers" element={<CustomerSearch />} />
          <Route path="/customers/bulk" element={<CustomersBulk />} />
          <Route path="/sales" element={<SalesCounter />} />
          <Route path="/cashier" element={<CashierQueue />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/inbound" element={<Inbound />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/permissions" element={<PermissionGrid />} />
          <Route path="/settings/users" element={<SettingsUsers />} />
          <Route path="/settings/catalog-import" element={<CatalogImport />} />
          <Route path="/settings/dsr" element={<DSRInbox />} />
          <Route path="/approvals" element={<ApprovalQueue />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/cashier/eod" element={<CashierEod />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
